import polyline from '@mapbox/polyline';

export class Idealista {
    static buildIdealistaUrl(lat: number, lng: number, size_sqm?: number): string {
        var base = "https://www.idealista.com/areas/venta-viviendas/";

        const filters: string[] = [];

        if (size_sqm && size_sqm!=0) {
            const size = Math.floor(size_sqm);

            let rounded: number, min_sqm: number, max_sqm: number;

            if (size > 200) {
                rounded = Math.round(size / 50) * 50;
                min_sqm = rounded - 50;
                max_sqm = rounded + 50;
            } else {
                rounded = Math.round(size / 10) * 10;
                min_sqm = rounded - 10;
                max_sqm = rounded + 10;
            }

            filters.push(`con-metros-cuadrados-mas-de_${min_sqm}`);
            filters.push(`metros-cuadrados-menos-de_${max_sqm}`);
            base = `${base}${filters.join(',')}/`;
        }

        const encodedShape = this.generateContinuousSquareDonutEncodedShape(lat, lng);
        const encodedShapeURI = encodeURIComponent(encodedShape);
        const uri = `${base}?shape=%28%28${encodedShapeURI}%29%29`;
        return uri;
    }

    private static generateContinuousSquareDonutEncodedShape(
        lat: number,
        lng: number,
        innerHalfSide = 5,    // 10m square
        outerHalfSide = 200,  // 500m square
        gap = 2               // 2m vertical gap on right sides
    ): string {
        const earthRadius = 6371000.0;

        const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

        const offset = (meters: number, latBase: number) => {
            const dLat = (meters / earthRadius) * (180 / Math.PI);
            const dLng = (meters / (earthRadius * Math.cos(toRadians(latBase)))) * (180 / Math.PI);
            return { dLat, dLng };
        };

        const inner = offset(innerHalfSide, lat);
        const outer = offset(outerHalfSide, lat);
        const halfGap = offset(gap / 2, lat);

        // ───── SMALL SQUARE (clockwise, partial) ─────
        const innerStart: [number, number] = [lat + halfGap.dLat, lng + inner.dLng]; // top-right (adjusted for gap)
        const innerPoints: [number, number][] = [
            innerStart,
            [lat + inner.dLat, lng + inner.dLng], // top-right corner
            [lat + inner.dLat, lng - inner.dLng], // top-left
            [lat - inner.dLat, lng - inner.dLng], // bottom-left
            [lat - inner.dLat, lng + inner.dLng], // bottom-right
            [lat - halfGap.dLat, lng + inner.dLng], // right side just before the gap
        ];

        // ───── Move to BIG SQUARE start ─────
        const moveToOuter: [number, number] = [lat - halfGap.dLat, lng + outer.dLng]; // vertically aligned

        // ───── BIG SQUARE (counter-clockwise, partial) ─────
        const outerPoints: [number, number][] = [
            moveToOuter,
            [lat - outer.dLat, lng + outer.dLng], // bottom-right
            [lat - outer.dLat, lng - outer.dLng], // bottom-left
            [lat + outer.dLat, lng - outer.dLng], // top-left
            [lat + outer.dLat, lng + outer.dLng], // top-right
            [lat + halfGap.dLat, lng + outer.dLng], // stop at same height as small start
        ];

        // ───── Return to INNER START ─────
        const closing = [innerStart];

        const allPoints: [number, number][] = [
            ...innerPoints,
            moveToOuter,
            ...outerPoints,
            ...closing,
        ];

        return polyline.encode(allPoints);
    }


}